import React, { useEffect, useState } from "react";
import Loader from "../../pages/Loader";
import { firestore } from "../../firebase";
import Cuadro from "../../Layout/Cuadro";
import { Typography, Grid } from "@mui/material/";
import tgame from "../../assets/images/tgame.png";
import ninocontrol from "../../assets/images/ninocontrol.png";
import a from "../../assets/images/a.png";
import b from "../../assets/images/b.png";
import c from "../../assets/images/c.png";
import d from "../../assets/images/d.png";
import { useUsuario } from "../../context/usuario-context";
import { styled } from "@mui/material/styles";
import myfuctions from "../../services/myfunctions";
import CheckIcon from "@mui/icons-material/Check";
import { useHistory } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";

const SendButtonSmall = styled(LoadingButton)(({ theme }) => ({
  color: theme.palette.getContrastText("#000"),
  backgroundColor: "#1a5080",
  "&:hover": {
    backgroundColor: "#85a537",
  },
  width: "150px",
  height: "40px",
  fontWeight: "bold",
  fontSize: "14px",
  borderRadius: "20px",
  lineHeight: 1.2,
  boxShadow:
    "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)",
}));

const CerrarButton = styled(LoadingButton)(({ theme }) => ({
  color: theme.palette.getContrastText("#000"),
  backgroundColor: "#1a5080",
  "&:hover": {
    backgroundColor: "#85a537",
  },
  width: "100px",
  height: "36px",
  fontWeight: "bold",
  fontSize: "12px",
  borderRadius: "20px",
  lineHeight: 1.2,
  boxShadow:
    "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)",
}));

function TriviaGame() {
  let history = useHistory();
  const { dataUser, config } = useUsuario();
  const [question, setQuestion] = useState(null);
  const [activeAnswer, setActiveAnswer] = useState(null);
  const [idQuestion, setIdQuestion] = useState(null);
  const [points, setPoints] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState(false);
  const [selectUpdate, setSelectUpdate] = useState(null);

  useEffect(() => {
    const onQuestions = firestore
      .collection("questions")
      .doc(`${config.listOrderTrivia[dataUser.questionsAnswered]}`)
      .onSnapshot((doc) => {
        if (doc.exists) {
          setQuestion(doc.data());
        } else {
          setQuestion(null);
        }
      });
    return () => {
      onQuestions();
    };
  }, [dataUser, config]);

  let selected = (indexA, points, idQuestion) => {
    setActiveAnswer(indexA);
    setPoints(points);
    setIdQuestion(idQuestion);
  };

  let update = async (points) => {
    setSelectUpdate(activeAnswer);
    try {
      setDisabled(true);
      await myfuctions
        .updateTrivia(dataUser.userId, dataUser.questionsAnswered, points)
        .then((result) => {
          setTimeout(() => {
            setDisabled(false);
            setPoints(0);
            setActiveAnswer(null);
            setSelectUpdate(null);
          }, 1900);
        })
        .catch((error) => {
          console.log(error);
          setError(true);
        });
    } catch (error) {
      console.log(error);
      setError(true);
    }
  };

  if (error) {
    return " Ha ocurrido un error";
  }

  return question ? (
    <Cuadro bgCuadro="#fff">
      <Grid container>
        <Grid item xs={12} className="containerTittle">
          <Typography
            variant="h6"
            gutterBottom
            component="div"
            className="tittleTGame"
            align="justify"
          >
            PREGUNTA {question.id}
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            component="div"
            className="question"
          >
            {question.tittle}
          </Typography>
        </Grid>
        <Grid item xs={12} md={8} style={{ paddingTop: "20px" }}>
          {question.answers
            ? question.answers.map((answer, indexA) => {
                return (
                  <Grid container key={indexA}>
                    <Grid
                      item
                      xs={12}
                      md={1}
                      sx={{ display: { xs: "none", md: "block" } }}
                    >
                      <img
                        className="letraPregunta"
                        src={
                          indexA === 0
                            ? a
                            : indexA === 1
                            ? b
                            : indexA === 2
                            ? c
                            : d
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={11}
                      className={`answer ${
                        activeAnswer === indexA &&
                        idQuestion === question.id &&
                        selectUpdate === null
                          ? "active"
                          : ""
                      } ${
                        selectUpdate !== null
                          ? question.correct !== indexA
                            ? activeAnswer === indexA
                              ? "active"
                              : "error"
                            : "correct"
                          : ""
                      } `}
                      onClick={() =>
                        selected(indexA, question.points[indexA], question.id)
                      }
                    >
                      <Typography
                        variant="body2"
                        gutterBottom
                        component="div"
                        className="answers"
                      >
                        {answer}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })
            : ""}
        </Grid>
        <Grid item xs={12} md={4} sx={{ display: { xs: "none", md: "block" } }}>
          <div className="divNino">
            <img src={tgame} alt="Chica" className="tgameImage" />
          </div>
        </Grid>
        <Grid item xs={11} style={{ textAlign: "center" }}>
          <SendButtonSmall
            variant="contained"
            onClick={() => update(points)}
            disabled={disabled || activeAnswer === null}
            loading={disabled}
            loadingPosition="start"
            startIcon={<CheckIcon />}
          >
            Responder
          </SendButtonSmall>
        </Grid>
      </Grid>
    </Cuadro>
  ) : dataUser.questionsAnswered === 10 ? (
    <Cuadro bgCuadro="#fff">
      <Grid container>
        <Grid item xs={12} className="cCongratulations">
          <Typography variant="h3" className="congratulations" align="justify">
            ¡FELICITACIONES!
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <div className="puntosImg">
            <Typography
              variant="subtitule1"
              className="textPuntos"
              align="center"
            >
              Respondiste<br></br>
              de manera correcta<br></br>
              <span className="puntos">
                {dataUser.numberTriviaCorrect} de 10
              </span>
              <br></br>
              <CerrarButton
                variant="contained"
                loadingPosition="start"
                style={{ marginTop: "10px" }}
                onClick={() => history.push("/")}
              >
                Cerrar
              </CerrarButton>
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={4} sx={{ display: { xs: "none", md: "block" } }}>
          <div className="divNino">
            <img src={ninocontrol} alt="Chica" className="ninocontrolImg" />
          </div>
        </Grid>
      </Grid>
    </Cuadro>
  ) : (
    <Loader />
  );
}

export default TriviaGame;
